import useSwr from "swr";
import { config } from "config.js";

/**
 * Fetches components by object ID.
 *
 * @param {string} pointComponentId - The ID of the component to fetch components for.
 * @return {object} - An object {data, error} containing the fetched data and any errors that occurred.
 */
const FetchEventsByComponentId = (pointComponentId) => {
  const { data, error } = useSwr(
    `${config.URL_BACKEND_PG}api/v1/point-events/components?pointComponentId=${pointComponentId}`
  );
  return { data, error };
};

export default FetchEventsByComponentId;
